export default {
  notAllEnvelopesWereCalculated: 'Not all envelopes were calculated',
  someEnvelopesAreInvalid: 'Some envelopes are invalid',
  commentRequiredNotPassed: 'Each envelope which had not passed requires a comment',
};
